import Switch from '@shared/components/Switch/Switch';
import { ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Chats } from 'assets/icons/Chats.svg';

import { ScheduleMeetingFormValues } from './types';

interface GroupChatToggleFieldProps {
  disabled?: boolean;
  /** When set with `onCheckedChange`, renders without react-hook-form context. */
  checked?: boolean;
  onCheckedChange?: (value: boolean) => void;
}

const GroupChatToggleLayout = ({ toggle }: { toggle: ReactNode }) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-2">
      <div className="md:px-3">
        <Chats className="mt-0.5 h-6 w-6 shrink-0 stroke-1.5 stroke-gray-60" />
      </div>
      <div className="flex w-full items-center justify-between">
        <div className="mr-4 flex flex-col gap-0.5">
          <span className="text-size-md text-black">{t('schedule_meeting.group_chat_label')}</span>
          <span className="text-size-sm text-gray-60">{t('schedule_meeting.group_chat_description')}</span>
        </div>
        {toggle}
      </div>
    </div>
  );
};

const GroupChatToggleFieldForm = ({ disabled }: { disabled?: boolean }) => {
  const { control } = useFormContext<ScheduleMeetingFormValues>();

  return (
    <GroupChatToggleLayout
      toggle={
        <Controller
          name="groupChat"
          control={control}
          render={({ field: { onChange, value } }) => (
            <Switch checked={!!value} onChange={onChange} disabled={disabled} />
          )}
        />
      }
    />
  );
};

const GroupChatToggleField = ({ disabled, checked, onCheckedChange }: GroupChatToggleFieldProps) => {
  if (onCheckedChange !== undefined) {
    return (
      <GroupChatToggleLayout toggle={<Switch checked={!!checked} onChange={onCheckedChange} disabled={disabled} />} />
    );
  }

  return <GroupChatToggleFieldForm disabled={disabled} />;
};

export default GroupChatToggleField;
